import * as locationTypes from "Store/locations/constants";

export const handleFetchLocations = (): locationTypes.IHandleFetchLocations => ({
  type: locationTypes.HANDLE_FETCH_LOCATIONS
});

export const handleFetchLocation = (locationId: string): locationTypes.IHandleFetchLocation => ({
  type: locationTypes.HANDLE_FETCH_LOCATION,
  payload: {
    locationId
  }
});

export const fetchActiveLocationSummary = (
  locationId: string
): locationTypes.IHandleFetchActiveLocationSummary => ({
  type: locationTypes.HANDLE_FETCH_ACTIVE_LOCATION_SUMMARY,
  payload: { locationId }
});

export const fetchCurrentLocation = (): locationTypes.IHandleFetchCurrentLocation => ({
  type: locationTypes.HANDLE_FETCH_CURRENT_LOCATION
});

export const handleUpdateLocation = (location: TLocation): locationTypes.IHandleUpdateLocation => ({
  type: locationTypes.HANDLE_UPDATE_LOCATION,
  payload: { location }
});

export const handleUpdateLocationInfo = (
  locationInfo: LocationRequest
): locationTypes.IHandleUpdateLocationInfo => ({
  type: locationTypes.HANDLE_UPDATE_LOCATION_INFO,
  payload: { locationInfo }
});

export const handleUpdateLocationBranding = (
  body: UpdateLocationBrandingRequest
): locationTypes.IHandleUpdateLocationBranding => ({
  type: locationTypes.HANDLE_UPDATE_LOCATION_BRANDING,
  payload: { body }
});

export const handleCreateLocation = (
  location: Partial<TLocation>
): locationTypes.IHandleCreateLocation => ({
  type: locationTypes.HANDLE_CREATE_LOCATION,
  payload: {
    location
  }
});

export const handleSetActiveLocation = (location: TLocation): locationTypes.ISetActiveLocation => ({
  type: locationTypes.SET_ACTIVE_LOCATION,
  payload: {
    location
  }
});

export const handleSetCurrentLocation = (
  location: TLocation
): locationTypes.ISetCurrentLocation => ({
  type: locationTypes.SET_CURRENT_LOCATION,
  payload: { location }
});

export const setLocations = (locations): locationTypes.ISetAllLocation => ({
  type: locationTypes.SET_ALL_LOCATIONS,
  payload: { locations }
});

export const setActiveLocationSummary = (
  locationSummary: LocationSummary
): locationTypes.ISetActiveLocationSummary => ({
  type: locationTypes.SET_ACTIVE_LOCATION_SUMMARY,
  payload: {
    locationSummary
  }
});

export const setLocationsSimplifiedLoading = (
  isLoading: boolean
): locationTypes.ISetLocationsSimplifiedLoading => ({
  type: locationTypes.SET_LOCATIONS_SIMPLIFIED_LOADING,
  payload: {
    isLoading
  }
});
